import {
  animate,
  group,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  HostListener,
  signal,
  ViewChild,
} from '@angular/core';
import { ChildrenOutletContexts, Router } from '@angular/router';
import { AuthService } from 'src/libs/auth/auth.service';
import { LoginHeaderService } from 'src/libs/state/login-header.service';
@Component({
  selector: 'fini-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('routeParent', [transition(':enter', [])]),
    trigger('routeAnimations', [
      transition('isDown => isLeft', slideTo('top')),
      transition('isDown => isRight', slideTo('top')),
      transition('isRight => isDown', slideTo('bottom')),
      transition('isLeft => isDown', slideTo('bottom')),
      transition('isRight => isLeft', slideTo('left')),
      transition('isLeft => isRight', slideTo('right')),
      transition('isRight => isRight', slideTo('right')),
      transition('isLeft => isLeft', slideTo('left')),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LoginComponent {
  constructor(private contexts: ChildrenOutletContexts, private props: LoginHeaderService, private router: Router, private auth: AuthService) {
    setTimeout(() => {
      if (!this.authcheck()) {
        this.auth.profile().subscribe();
      }
    }, 2500);
  }

  @HostListener('window:profile:loaded', ['$event'])
  onProfileLoaded(event: CustomEvent) {
    const { profile, servers } = event.detail;

    this.authcheck.set(true);
    if (profile !== null) {
      this.router.navigate([servers !== null ? '/dashboard' : '/profile']);
    }
  }

  authcheck = signal(false);
  footerLinks = [
    { url: '/login', text: 'Login' },
    { url: '/register', text: 'Register' },
    { url: '/forgot', text: 'Forgot password?' },
  ];
  header = computed(() => {
    return this.props.get()()
  });

  @ViewChild('routerPane') routerPane: ElementRef;
  routerHeight = 0;

  animationDone() {
    this.routerHeight = this.routerPane.nativeElement.clientHeight;
  }

  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.[
      'animation'
    ];
  }
}

// helper to create slide animations
function slideTo(direction: string) {
  const optional = { optional: true };
  return [
    query(':self', [style({ height: '{{startHeight}}px' })]),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          // top: 0, // removing this to make it slide down
          [direction]: direction === "top" ? '107px' : direction === "bottom" ? 'var(--login-anim-bottom-padding)' : "20px",

          width: 'calc(100% - 2.5em)',
        }),
      ],
      optional
    ),
    query(':enter', [style({ [direction]: '-110%', opacity: '0%', transform: 'scale(0.7)' })]),
    group(
      [
        query(':self', [animate('300ms ease-in-out', style({ height: '*' }))]),
        query(
          ':leave',
          [
            animate(
              '300ms ease-in-out',
              style({ [direction]: '110%', opacity: '0%', transform: 'scale(0.7)' })
            ),
          ],
          optional
        ),
        query(
          ':enter',
          [
            animate(
              '300ms ease-in-out',
              style({ [direction]: direction === "top" ? '107px' : direction === "bottom" ? 'var(--login-anim-bottom-padding)' : "20px", opacity: '100%', transform: 'scale(1)' })
            ),
          ],
          optional
        ),
      ],
      {
        params: { startHeight: 0 },
      }
    ),
  ];
}
